import { Writable, writable } from 'svelte/store';
import { IPopupProps } from '../interfaces';

const ModalStore = (): {
  openModal: (modalProps: IPopupProps) => void;
  store: Writable<IPopupProps[]>;
} => {
  const { set, subscribe, update } = writable<IPopupProps[]>([]);
  const openedModals: IPopupProps[] = [];
  const popAndContinue = () => {
    openedModals.pop();
    set(openedModals);
  };
  // Public helper method to open a modal
  const openModal = (modalProps: IPopupProps) => {
    try {
      const newModal: IPopupProps = {
        // Set the modal
        modal: modalProps.modal,
        onClose: () => {
          if (modalProps.onClose) modalProps.onClose();

          // Handle next modal in queue
          popAndContinue();
        },
        onSubmit: (data) => {
          if (modalProps.onSubmit) modalProps.onSubmit(data);

          // Handle next modal in queue
          popAndContinue();
        },
        data: modalProps.data || {},
      };

      // Add new modal to the queue
      openedModals.push(newModal);
      set(openedModals);
    } catch (error) {
      console.error(error);
      // Make sure to continue
      popAndContinue();
    }
  };

  return {
    openModal,
    store: {
      subscribe,
      set,
      update,
    },
  };
};

export const ModalService = ModalStore();
